<div class="kt-portlet">
    <!-- <div class="kt-portlet__head"> -->
    <div class="kt-portlet__head  d-flex align-items-center justify-content-between">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Yeni Destek Talebi
            </h3>
        </div>
        <button type="button" routerLink="/my-requests" class="btn btn-secondary">Geri Dön</button>
        <!-- </div> -->
    </div>

    <!--begin::Form-->
    <form class="kt-form kt-form--label-right" [formGroup]="insertUserRequest" (ngSubmit)="save()" autocomplete="off">
        <div class="kt-portlet__body">
            <div class="form-group">
                <label for="requestType" class="col-form-label">Kategori</label>
                <ng-select name="requestType" id="requestType" labelForId="requestType" bindValue="code"
                    style="width: 100%" placeholder="Kategori" [items]="requestTypes" bindLabel="text"
                    formControlName="requestType">
                </ng-select>
                <small class="form-text text-warning" *ngIf="f.requestType.errors?.required">Lütfen kategori
                    seçiniz!</small>
            </div>
            <div class="form-group">
                <label for="title" class="col-form-label">Başlık:</label>
                <input class="form-control" type="text" id="title" name="title" formControlName="title"
                    placeholder="Başlık">
                <small class="form-text text-warning" *ngIf="f.title.errors?.required">Lütfen başlık
                    giriniz!</small>
                <small class="form-text text-warning" *ngIf="f.title.errors?.maxlength">Lütfen en fazla 100
                    haneli bir başlık giriniz!</small>
            </div>
            <div class="form-group">
                <label class="col-form-label">Talep içeriği</label>

                <textarea formControlName="message" rows="3" class="form-control"
                    placeholder="Talep içeriği"></textarea>
                <small class="form-text text-warning" *ngIf="f.message.errors?.required">Lütfen talep içeriği
                    giriniz!</small>
                <small class="form-text text-warning" *ngIf="f.message.errors?.maxlength">Lütfen en fazla 1000 haneli
                    bir talep içeriği giriniz!</small>
            </div>
        </div>
        <div class="kt-portlet__foot">
            <div class="kt-form__actions">
                <div class="row">
                    <div class="col-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-primary mr-3" (click)="save()">Kaydet</button>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <!--end::Form-->
</div>